/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectCloudBackupPlan from 'modules/me/select-cloud-backup-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-cloud-backup/selectors';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ScheduledChangesNotice from 'modules/me/cloud-backup/scheduled-changes-notice';

const EditPlan = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Cloud Backup Plan Billing - Tower Systems' />
            <Topbar title='Cloud Backup Plan' subTitle='Manage your Cloud Backup subscription' selected='cloud-backup'>
                <Button primary link='/dashboard/cloud-backup'>
                    View Subscription Details
                </Button>
            </Topbar>
            {props.hasScheduledChanges && (
                <Box marginBottom='xxlarge'>
                    <ScheduledChangesNotice></ScheduledChangesNotice>
                </Box>
            )}
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Cloud Backup plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a Cloud Backup plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box>
                        <SelectCloudBackupPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(EditPlan);
